import { Switch, Menu, OverflowText } from "@theorgchartdev/storybook";
import React from "react";
import cx from "classnames";
import { FieldSelectListProps } from "@/Utils/ComponentLib";
import { DATA_SOURCES_TEST_PREFIX } from "./Utils";

const SwitchWrapper = ({ checked, onChange, option, dataTestId }) => {
  const handleSwitchChange = event => {
    onChange(option, checked);
    event.stopPropagation();
  };
  return <Switch data-testid={dataTestId} checked={checked} onChange={handleSwitchChange} />;
};

const BuildOptions = (selectedTables, tableOptions, onChange, small) => {
  let fieldOptions = [];
  let baseClass = "ocn-field-toggle-option";
  let textSize = small ? "xsmall" : "small";
  for (let field of tableOptions) {
    let value = field.value;
    let label = field.label;
    let checked =
      selectedTables.findIndex(sourceItem => JSON.stringify(sourceItem) === JSON.stringify(value)) >
        -1 || selectedTables.map(item => item.value).includes(value);

    let checkedClass = checked && `${baseClass}-label--checked`;
    let fieldOption = {};

    fieldOption.content = (
      <span className={baseClass}>
        <span className={cx(`${baseClass}-label`, checkedClass)}>
          <OverflowText className="oc-block oc-fill-width" size={textSize}>
            {label}
          </OverflowText>
        </span>
        <span className={`${baseClass}-switch`}>
          <SwitchWrapper
            id={"directory-column-fields-" + field}
            dataTestId={`${DATA_SOURCES_TEST_PREFIX}-table-field-toggle-${value}`}
            checked={checked}
            option={fieldOption}
            onChange={onChange}
          />
        </span>
      </span>
    );
    // menu option callback passes back option obj which contains the value and callback fn handles extraction
    fieldOption.clickHandler = onChange;
    fieldOption.value = field;
    fieldOption.label = label;
    fieldOptions.push(fieldOption);
  }
  return fieldOptions;
};

const AdditionalTableFieldToggleMenu = ({
  selectedOptions = [],
  allOptions = [],
  label,
  placeholder,
  inputOnly = false,
  tableKey,
  config,
  index,
  onChange,
  small,
  dataTestId,
  ...selectProps
}) => {
  let selectOptions = BuildOptions(selectedOptions, allOptions, onChange, small);
  selectProps = {
    ...selectProps,
    listProps: {
      ...selectProps?.listProps,
      ...FieldSelectListProps({
        customPlaceholder: selectProps?.listProps?.placeholder,
        customNoResultsText: selectProps?.listProps?.noResultsText
      }),
      listWidth: small
    }
  };
  // TODO show list of selected values in placeholder
  return (
    <Menu
      dataTestId={dataTestId || `${DATA_SOURCES_TEST_PREFIX}-table-field-toggle-menu`}
      label={label}
      options={selectOptions}
      stayOpenOnOptionSelect={true}
      {...selectProps}
    />
  );
};

export default AdditionalTableFieldToggleMenu;
